<template>
  <v-dialog v-model="showModal" max-width="500px" persistent>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Status weryfikacji P1</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <p v-if="isCorrect" style="color:green">Wszystkie dane są poprawne</p>
              <ul v-if="!isCorrect">
                <li v-for="(err,index) in errors_p1" :key="index">
                  {{err}}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import swal from "sweetalert";
import {visitService} from "@/services";

export default {
  name: "P1Verify",
  props: ["visible","visitid"],
  data() {
    return {
      isCorrect: false,
      errors_p1: []
    }
  },
  mounted(){
      visitService.VerifyVisitP1(this.visitid).then((result) => {
        this.errors_p1 = result.data.result.errors
        this.isCorrect = result.data.result.isCorrect
      }).catch(() => {
        this.showError('Nie można pobrac statusu weryfikacji P1',true)
      })
  },
  methods: {
    showError(text, close) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
            if (close) {
              this.showModal = false
            }
          }
      )

    },
  },
  computed: {
    showModal: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }

      }
    }
  },
}
</script>

<style scoped>

</style>